import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { scrollToTargetAdjusted } from '../../../utils/ui';


const P = styled.p`
    ${(props) => props.color && `color: ${props.color} !important;`}
    ${(props) => props.fontSize && `font-size: ${props.fontSize} !important;`}
    ${(props) =>
        props.fontFamily && `font-family: ${props.fontFamily} !important;`}
`;

const Text = (props) => {
    const {
        content,
        color,
        fontSize,
        fontFamily,
        className,
        children,
        path,
        onClick,
        scrollTo,
        showReadMore, // Add this prop
    } = props;

    const [isExpanded, setIsExpanded] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false); // To track screen size
    const history = useHistory();

    const changePath = (path) => {
        history.push(path);
    };

    const onClickHandler = (type) => {
        switch (type) {
            case 'CHANGE_PATH':
                return changePath(path);
            case 'SCROLL':
                return scrollToTargetAdjusted(scrollTo);
            default:
                return;
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1024); // Set to true for screens smaller than lg (1024px)
        };

        // Check the initial screen size
        handleResize();

        // Listen to screen resize events
        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (!content) {
        return <p></p>;
    } else {
        // Set a max length for text truncation
        const maxLength = 130;
        const truncatedContent = content.substring(0, maxLength);
        const fullContent = content;

        // If the text is expanded, show the full content, otherwise show the truncated content
        const displayedContent = isExpanded || !isSmallScreen ? fullContent : truncatedContent;

        return (
            <>
                <p
                    color={color}
                    fontSize={fontSize}
                    fontFamily={fontFamily}
                    className={className || ''}
                    onClick={() => onClickHandler(onClick)}
                >
                    {/* {children}  */}
                    {showReadMore ? displayedContent : children}
                    {showReadMore && isSmallScreen && !isExpanded && (
                    <span
                        onClick={() => setIsExpanded(true)}
                        className={ ` ${className} !font-normal `}
                       
                    >
                        ...Read More
                    </span>
                )}
                </p>
                {showReadMore && isSmallScreen && isExpanded && (
                    <span
                        onClick={() => setIsExpanded(false)}
                        className={ `${className} !font-normal `}
                    >
                       {' '} Read Less
                    </span>
                )}

                
               
            </>
        );
    }
};

export default Text;

